import ClientsAxios from '../client-axios';
import { ResponseEntity } from '../dto/response';

const { API_SERVER } = ClientsAxios;


export const SewaMasterListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaCategoryListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-category/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaDalListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-dal/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaVolunteerListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-volunteer/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaVolunteerDetailsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-volunteer/details', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaCategoryStoreService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-category/create', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaStoreService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa/create', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaVolunteerStoreService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-volunteer/create', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaDalStoreService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-dal/create', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaCategoryUpdateService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-category/update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaVolunteerUpdateService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-volunteer/update', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaUpdateService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa/update', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaDalUpdateService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-dal/update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaCategoryDeleteService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-category/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaDalDeleteService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-dal/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaDeleteService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}

export const SewaVolunteerDeleteService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('sewa-volunteer/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response?.data?.body ?? null)
    }
    return responseEntity
}